<template>
  <div class="page">
    <el-container style="padding: 20px 0;border-bottom: 1px solid #f4f4f4;" class="main-container">
      <!-- 现代化加载遮罩 -->
      <transition name="fade">
        <div v-if="loading" class="modern-loading-overlay">
          <div class="loading-content">
            <div class="loading-spinner">
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
              <div class="spinner-ring"></div>
            </div>
            <div class="loading-text">试卷加载中</div>
            <div class="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </transition>
      
      <el-aside>
        <asideLeft :testPaperInfo="testPaperInfo" :answerArr="answerArr" :allQuestionArr="allQuestionArr"
                   @submitPaper="submitPaper" @forceSubmitPaper="forceSubmitPaper" :suggestTime="suggestTime" @changeMaodian="changeMaodian">
        </asideLeft>
      </el-aside>
      <el-container>
        <el-main>
          <mainDetails ref="mainDetails" @isAnswerArr="isAnswerArr" :allQuestionArr="allQuestionArr"
                       :paperTitle="paperTitle" :maodian="maodian"></mainDetails>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import asideLeft from "./components/asideLeft.vue"
import headerDetails from "./components/headerDetails.vue"
import mainDetails from "./components/mainDetails.vue"
import {
  getPaperDetails
} from "@/api/index.js"


export default {
  components: {
    asideLeft,
    headerDetails,
    mainDetails
  },
  data() {
    return {
      allNumberArr: [],
      answerArr: [],
      allQuestionArr: [],
      paperTitle: '',
      testPaperId: null,
      studentWorkInfoId: null,
      testPaperInfo: {},
      suggestTime: null,
      loading: true,
      maodian: '#1'
    }
  },
  created() {
    // this.$nextTick(() => {
    // 	// 禁用右键
    // 	document.oncontextmenu = new Function("event.returnValue=false");
    // 	// 禁用选择
    // 	document.onselectstart = new Function("event.returnValue=false");
    // });
  },
  mounted() {
    this.testPaperId = this.$route.query.id;
    this.studentWorkInfoId = this.$route.query.studentWorkInfoId;
    this.getInfo(this.testPaperId)
  },
  methods: {
    //定位到选中的题目的位置
    changeMaodian(idName) {
      this.maodian = idName
    },
    isAnswerArr(item) {
      this.answerArr = item
    },
    getInfo(id) {
      this.loading = true
      getPaperDetails(id).then(res => {
        // console.log(res)
        if (res.code === "0000") {
          this.testPaperInfo = res.data
          this.paperTitle = res.data.name
          this.allQuestionArr = res.data.titleItems

          this.suggestTime = res.data.suggestTime
          let numberArr = []
          res.data.titleItems.forEach(item => {
            if (item.questionItems) {
              item.questionItems.forEach(item1 => {
                numberArr.push(item1.itemOrder)
              })
            }

          })
          this.allNumberArr = numberArr
          this.loading = false
        }
      }).catch(() => {
        this.loading = false

        if (localStorage.getItem("token")) {
        } else {
          showLogin();
        }

        this.$router.push({
          path: '/'
        })

        // this.loading = false
        // this.$confirm('此作品，非VIP用户不可操作', '提示', {
        //     confirmButtonText: '确定',
        //     cancelButtonText: '开通会员',
        //     type: 'warning'
        // }).then(() => {
        //     window.close()
        // }).catch(() => {
        //     this.$router.push({
        //         path: '/selfVIP'
        //     })
        // });
      });
    },
    submitPaper(time) {
      this.$refs.mainDetails.submitSubject(this.testPaperInfo.id, this.studentWorkInfoId, time);
    },
    // 强制提交试卷（考试时间到时自动调用）
    forceSubmitPaper(time) {
      this.$refs.mainDetails.forceSubmitSubject(this.testPaperInfo.id, this.studentWorkInfoId, time);
    }
  }
};
</script>

<style lang="scss" scoped>
.page {

  min-height: 100vh;
}

.el-container {
  background: transparent;
  align-items: flex-start;
}

.el-aside {
  color: #333;
  width: 300px;
  background: #FFFFFF !important;
  padding-bottom: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
  position: sticky;
  top: 20px;
  align-self: flex-start;
  height: 100vh;
  overflow-x: hidden;
  border: 1px solid rgba(255, 255, 255, 0.8);
}

.el-main {
  margin-left: 20px;
  background: #FFFFFF !important;
  width: 945px;
  overflow: visible;
  border-radius: 8px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 32px 40px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.04);
  }
}

/* 现代化加载样式 */
.main-container {
  position: relative;
}

.modern-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  border-radius: 8px;
  min-height: 600px;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.loading-spinner {
  position: relative;
  width: 80px;
  height: 80px;
}

.spinner-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  animation: spin 1.5s ease-in-out infinite;
}

.spinner-ring:nth-child(1) {
  border-top-color: #409EFF;
  animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
  width: 60px;
  height: 60px;
  top: 10px;
  left: 10px;
  border-right-color: #67C23A;
  animation-delay: 0.15s;
  animation-direction: reverse;
}

.spinner-ring:nth-child(3) {
  width: 40px;
  height: 40px;
  top: 20px;
  left: 20px;
  border-bottom-color: #E6A23C;
  animation-delay: 0.3s;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-text {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
  letter-spacing: 2px;
}

.loading-dots {
  display: flex;
  gap: 8px;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  background: #409EFF;
  border-radius: 50%;
  animation: bounce 1.4s ease-in-out infinite;
}

.loading-dots span:nth-child(1) {
  animation-delay: 0s;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
  background: #67C23A;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
  background: #E6A23C;
}

@keyframes bounce {
  0%, 80%, 100% {
    transform: scale(0.6);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
